import { Box, Skeleton, Stack, Typography } from '@mui/material';

export const DashboardDetailsLoading = () => {
  return (
    <Stack direction="row" spacing={1}>
      <Box py={0.5}>
        <Skeleton variant="circular" width={40} height={40} />
      </Box>
      <Stack>
        <Typography variant="h6">
          <Skeleton width={250} />
        </Typography>
        <Typography variant="subtitle1">
          <Skeleton width={400} />
          <Skeleton width={600} />
        </Typography>
      </Stack>
    </Stack>
  );
};
